import ModalAlertWarning from '../shared/modals/modalAlertWarning';
import ModalSuccess from '../shared/modals/modalSuccess';

const Modals = ({
  showNotFound, notFound, onCloseNotFound,
  showError, errorMessage, onCloseError,
  showSuccess, successMessage, onCloseSuccess,
  showConfirm, flaggedSuppliers, onConfirm, onDownloadFlagged, onCloseConfirm,
  showMaxExceeded, maxExceededSuppliers, onDownloadMaxExceeded, onCloseMaxExceeded
}) => (
  <>
    <ModalAlertWarning
      showModalAlertWarning={showNotFound}
      closeModal={onCloseNotFound}
      error={
        <div className="flex flex-col items-center">
          <p className="mb-4 text-center font-itcdemi">
            Proveedores no encontrados
          </p>
          <ul className="w-full overflow-auto list-disc list-inside font-itcbook max-h-60">
            {notFound.map((code, i) => (
              <li key={i}>Código: {code}</li>
            ))}
          </ul>
        </div>
      }
      accept={onCloseNotFound}
    />

    <ModalAlertWarning
      showModalAlertWarning={showError}
      closeModal={onCloseError}
      error={errorMessage}
      accept={onCloseError}
    />


    <ModalSuccess
      showModalSuccess={showSuccess}
      closeModalSuccess={onCloseSuccess}
      text={successMessage}
      excel={false}
      fill="green"
    />

    <ModalAlertWarning
      showModalAlertWarning={showConfirm}
      closeModal={onCloseConfirm}
      error={
        <div className="flex flex-col items-center w-full">
          <p className="mb-6 text-center">
            Se detectaron <span className="font-medium">{flaggedSuppliers.length}</span> proveedores con 3 o más anuncios.<br />
            ¿Deseas continuar con la publicación?
          </p>
          <div className="flex flex-col justify-center w-full gap-3 sm:flex-row">
            <button
              onClick={onCloseConfirm}
              className="px-4 py-2 text-white transition rounded shadow bg-gray"
            >
              Cancelar
            </button>
            <button
              onClick={onDownloadFlagged}
              className="px-4 py-2 text-white transition rounded shadow bg-blue"
            >
              Descargar Excel
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 text-white transition rounded shadow bg-green"
            >
              Aceptar
            </button>
          </div>
        </div>
      }
      accept={false}
      showAcceptButton={false}
      color="#CA2D00"
    />

    <ModalAlertWarning
      showModalAlertWarning={showMaxExceeded}
      closeModal={onCloseMaxExceeded}
      error={
        <div className="flex flex-col items-center w-full">
          <p className="mb-6 text-center">
            Se detectaron{' '}
            <span className="font-medium">{maxExceededSuppliers.length}</span>{' '}
            proveedores con 5 anuncios activos.<br />
            Por favor elimínalos antes de continuar.
          </p>
          <div className="flex flex-col justify-center w-full gap-3 sm:flex-row">
            <button
              onClick={onCloseMaxExceeded}
              className="px-4 py-2 text-white transition rounded shadow bg-gray"
            >
              Cerrar
            </button>
            <button
              onClick={onDownloadMaxExceeded}
              className="px-4 py-2 text-white transition rounded shadow bg-blue"
            >
              Descargar Excel
            </button>
          </div>
        </div>
      }
      accept={false}
      showAcceptButton={false}
      color="#CA2D00"
    />
  </>
);

export default Modals;